import * as actionTypes from "../action-types";

const initialState = {
    //! Address
    customerAddressData: [],

    //! History
    pitrPakshaHistoryData: [],
    rechargeHistoryData: [],
    yatraHistoryData: [],
    productHistoryData: [],
    pujaHistoryData: [],
};

const customerReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        //! Address
        case actionTypes.SET_CUSTOMER_ADDRESS:
            return { ...state, customerAddressData: payload };

        //! History
        case actionTypes.SET_RECHARGE_HISTORY:
            return { ...state, rechargeHistoryData: payload };

        case actionTypes.SET_YATRA_HISTORY:
            return { ...state, yatraHistoryData: payload };

        case actionTypes.SET_PRODUCT_HISTORY:
            return { ...state, productHistoryData: payload };

        case actionTypes.SET_PUJA_HISTORY:
            return { ...state, pujaHistoryData: payload };

        case actionTypes.SET_PITR_PAKSHA_HISTORY:
            return { ...state, pitrPakshaHistoryData: payload };

        default:
            return state;
    }
};

export default customerReducer;